import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { WarehouseService } from "../warehouse.service";
@Component({
  selector: "app-warehouse-list",
  templateUrl: "./warehouse-list.component.html",
  styleUrls: ["./warehouse-list.component.sass"],
})
export class WarehouseListComponent implements OnInit {
  allRequirements: any[] = [];
  page = 1;
  limit = 5;
  totalCount = 0;
  totalPages = 0;
  isLoading = false;

  constructor(
    private warehouseService: WarehouseService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getWarehouseRequirementList();
  }

  getWarehouseRequirementList() {
    this.isLoading = true;

    const body = {
      page: this.page,
      perPage: this.limit,
    };

    this.warehouseService.getWarehouseRequirementsList(body).subscribe(
      (response: any) => {
        this.isLoading = false;

        if (response.statusCode === 200) {
          this.allRequirements = response.data;
          this.totalCount = response.totalCount;
          this.totalPages = response.totalPages;
        }
      },
      (error) => {
        this.isLoading = false;
        console.log(error);
      },
    );
  }

  viewUserDetails(id: string) {
    this.router.navigate(["/dashboard/view-warehouse-requirements"], {
      queryParams: { id },
    });
  }

  changePage(page: number) {
    this.page = page;
    this.getWarehouseRequirementList();
  }
}
